<template>
  <list-table
    :url="transactions.url"
    title="لیست کارت های ملی و سلفی ها"
    :fields="transactions.fields"
    :params="transactions.params"
    :detailCallFun="transactions.detailCallFun"
    :detailCallFunType="transactions.detailCallFunType"
    @handle_function_call="ShowDetail"
  ></list-table>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TableShowData from "../../components/table";
import httpHelper from "../../helpers/httpHelper";
export default {
  name: "NationalcardConfirmation",
  components: {
    "list-table": TableShowData,
  },
  data() {
    return {
      transactions: {
        detailCallFunType: "id",
        detailCallFun: "ShowDetail",
        url: "getConfList",
        fields: [
          {
            key: "name",
            label: "نام",
          },
          {
            key: "mobile",
            label: "تلفن همراه",
          },
          {
            key: "email",
            label: "پست الکترونیکی",
          },
          {
            key: "melli",
            label: "تایید کارت ملی",
            formatter(value, key, item) {
              switch (value) {
                case 1522:
                  return "تایید شده";
                case 1520:
                  return "ارسال نشده";
                case 1521:
                  return "در انتظار تایید مدیر";
                default:
                  return "---";
              }
            },
            tdClass(value, key, item) {
              switch (value) {
                case 1522:
                  return "text-success";
                case 1521:
                  return "text-warning";
                default:
                  return "text-danger";
              }
            },
          },
          {
            key: "selfie",
            label: "تایید سلفی",
            formatter(value, key, item) {
              switch (value) {
                case 1522:
                  return "تایید شده";
                case 1520:
                  return "ارسال نشده";
                case 1521:
                  return "در انتظار تایید مدیر";
                default:
                  return "---";
              }
            },
            tdClass(value, key, item) {
              switch (value) {
                case 1522:
                  return "text-success";
                case 1521:
                  return "text-warning";
                default:
                  return "text-danger";
              }
            },
          },
          {
            key: "business_license",
            label: "جواز کسب",
            formatter(value, key, item) {
              switch (value) {
                case 1522:
                  return "تایید شده";
                case 1520:
                  return "ارسال نشده";
                case 1521:
                  return "در انتظار تایید مدیر";
                default:
                  return "---";
              }
            },
            tdClass(value, key, item) {
              switch (value) {
                case 1522:
                  return "text-success";
                case 1521:
                  return "text-warning";
                default:
                  return "text-danger";
              }
            },
          },
          {
            key: "details",
            label: "جزییات",
          },
        ],
        params: [
          {
            label: "نام و نام خانوادگی",
            field: "name",
            type: "text",
          },
          {
            label: "تلفن همراه",
            field: "mobile",
            type: "text",
          },
          {
            label: "پست الکترونیکی",
            field: "email",
            type: "text",
          },
          {
            label: "کارت ملی:",
            field: "melli",
            type: "mddropdown",
            group: 7,
          },
          {
            label: "عکس سلفی:",
            field: "selfie",
            type: "vselect",
            type: "mddropdown",
            group: 7,
          },
          {
            label: "جواز کسب:",
            field: "business_license",
            type: "vselect",
            type: "mddropdown",
            group: 7,
          },
        ],
      },
    };
  },
  methods: {
    ShowDetail(item, type) {
      this.$router.push("ConfirmNationalCode/" + item.id);
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "لیست کارت های ملی و سلفی ها" },
    ]);
  },
};
</script>
